import { API } from '@Providers';
import type { CompleteSplitPaymentPayload } from '../interfaces';

export default async function (payload: CompleteSplitPaymentPayload) {
  const endpoint = '/api/shelter/cart/complete-outcome-split-payment';

  localStorage.removeItem('cart-uploaded-files');
  localStorage.removeItem('cart-files-ids');

  return API({ endpoint, method: 'post', payload });
}
